import React from 'react'

// import { Container } from './styles';

function MbWay() {
  return <div />
}

export default MbWay
